module.exports = __webpack_public_path__ + "static/img/1810_9.3822bb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/1810_9.jpg
// module id = d/4I
// module chunks = 1